export function processData(rawData, IDKey) {
  const processedList = [];
  rawData.forEach((item) => {
    const x = {
      label: item.name || item.label || item.formName || item.title,
      value: item.name || item.label || item.formName || item.title,
      id: item[IDKey],
      ...item
    };
    processedList.push(x);
  });
  return processedList;
}
